export default __webpack_public_path__ + "static/media/tensorflow.3a11546f.png";